/*  新增代码  */
/* 增加：可复用的初始化函数 和 状态变量 */
let resizableInitialized = false;
function initResizable() {
  // 如果已经初始化，则先 unset 再初始化，避免重复绑定
  try { interact('.resizable').unset(); } catch (e) {}
  interact('.resizable').resizable({
    edges: { left: true, right: true, bottom: true, top: true },
    listeners: {
      move (event) {
        let { x, y } = event.target.dataset
        x = (parseFloat(x) || 0) + event.deltaRect.left
        y = (parseFloat(y) || 0) + event.deltaRect.top

        Object.assign(event.target.style, {
          width: `${event.rect.width}px`,
          height: `${event.rect.height}px`,
          // transform: `translate(${x}px, ${y}px)`
        })

        Object.assign(event.target.dataset, { x, y })
      }
    },
    modifiers: [
      interact.modifiers.restrictSize({
        min: { width: 280, height: 200 },
        max: { width: 600, height: 560 }
      })
    ],
    inertia: true
  });
  resizableInitialized = true;
}